import { Link } from 'gatsby'
import React, { FC, MouseEventHandler, useCallback, useState } from 'react'
import type { UseFormMethods } from 'react-hook-form'
import styled from 'styled-components'

import { PractitionerSettings } from '../../../../../../lib/practitioner-settings/types'
import DispensaryOptOutModal from './DispensaryOptOutModal'
import * as Styled from './styled'
import VirtualDispensaryInboundPatient from './VirtualDispensaryInboundPatient'

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.royalBlue.shade500};
`

const StyledContainer = styled.div`
  cursor: pointer;
`

const stopPropagation: MouseEventHandler = (evt) => {
  evt.stopPropagation()
}

export interface DispensingOptionVirtualDispensaryProps {
  className?: string
  control: UseFormMethods['control']
  isSubmitting: boolean
  register: UseFormMethods['register']
  settings: PractitionerSettings
}

const DispensingOptionVirtualDispensary: FC<DispensingOptionVirtualDispensaryProps> = ({
  className,
  control,
  isSubmitting,
  register,
  settings,
}) => {
  const { optedOutOfDispensary } = settings.practitioner
  const [isOpen, setIsOpen] = useState(false)
  const toggleModal = useCallback(() => {
    setIsOpen((prevState) => !prevState)
  }, [])

  return (
    <>
      <div className={className}>
        <StyledContainer onClick={toggleModal}>
          <h3 className="small-h3">Virtual Dispensary</h3>
          <Styled.Description>
            Simple, fast and turn key. No special code is required for patients to access or
            purchase products on your own virtual dispensary link. This is a free personalized
            e-store to strengthen your connection with your patients. DFH fulfills all the orders on
            your behalf, and you reap the benefits and commissions. <br /> <br /> Click{' '}
            <StyledLink to={'/account/dispensary'} onClick={stopPropagation}>
              here
            </StyledLink>{' '}
            to see details about your Virtual Dispensary.
          </Styled.Description>
          <Styled.DispensaryToggle
            name="virtualDispensary"
            control={control}
            defaultChecked={!optedOutOfDispensary}
            preventChange
          >
            <Styled.Label>Virtual Dispensary</Styled.Label>
          </Styled.DispensaryToggle>
        </StyledContainer>
        {/*<DispensaryOrderEmailsOptOut settings={settings} control={control} register={register} />*/}
        <VirtualDispensaryInboundPatient
          control={control}
          isSubmitting={isSubmitting}
          register={register}
          settings={settings}
        />
      </div>
      <DispensaryOptOutModal
        optedOutOfDispensary={optedOutOfDispensary}
        isOpen={isOpen}
        toggleModal={toggleModal}
      />
    </>
  )
}

export default DispensingOptionVirtualDispensary
